import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  isLobbyV2Path,
  LEGACY_PATHS,
} from "../../universal/v2Routes";

export default function useUiExperimentLobbySync(
  isAuthenticated,
  autoLoginInProgress,
  actions
) {
  const location = useLocation();

  useEffect(() => {
    if (!isAuthenticated || autoLoginInProgress || !actions?.refreshSessionUser) {
      return;
    }

    const pathname = location.pathname;
    const isLegacyLobby = pathname === LEGACY_PATHS.lobby;
    const isV2Lobby = isLobbyV2Path(pathname);
    if (!isLegacyLobby && !isV2Lobby) {
      return;
    }

    (async () => {
      try {
        await actions.refreshSessionUser();
      } catch {
        // Non-fatal: lobby remains usable if experiment sync fails.
      }
    })();
  }, [
    actions,
    autoLoginInProgress,
    isAuthenticated,
    location.pathname,
  ]);
}
